import { render, staticRenderFns } from "./DNCImport.vue?vue&type=template&id=7940cbed"
import script from "./DNCImport.vue?vue&type=script&lang=js"
export * from "./DNCImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports